export default __webpack_public_path__ + "static/image12-27cf094f0cc9f7fdd1a6ccdb0c40e09c.gif";